import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import styles from "../App.module.css";
import { MarketingFooter, MarketingNav } from "../Components/MarketingSite";
import { Box, Container, Typography, CircularProgress, Link } from "@mui/material";
import API from "../API";

const TopupSuccess = () => {
  const location = useLocation();
  const [status, setStatus] = useState("loading"); // loading | success | duplicate | error
  const [purchasedBalance, setPurchasedBalance] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const sessionId = params.get("session_id");
    if (!sessionId) {
      setStatus("error");
      return;
    }
    API.confirmTopup(sessionId)
      .then((result) => {
        if (result.success) {
          setStatus("success");
          setPurchasedBalance(result.purchasedBalance);
        } else if (result.reason === "duplicate_order") {
          setStatus("duplicate");
        } else {
          setStatus("error");
        }
      })
      .catch(() => setStatus("error"));
  }, [location.search]);

  return (
    <main className={styles.landingPage}>
      <MarketingNav currentPage="topup" />
      <Container className={styles.topupSuccessContent} maxWidth="sm">
        {status === "loading" && (
          <Box sx={{ marginTop: 6 }}>
            <CircularProgress />
            <Typography variant="h6" sx={{ marginTop: 3 }}>
              Confirming your purchase&hellip;
            </Typography>
          </Box>
        )}

        {status === "success" && (
          <>
            <Typography variant="h3" gutterBottom>
              Credits added!
            </Typography>
            <Typography variant="h6" color="text.secondary" sx={{ marginBottom: 4 }}>
              Your new purchased balance is {purchasedBalance} credits.
            </Typography>
          </>
        )}

        {status === "duplicate" && (
          <>
            <Typography variant="h3" gutterBottom>
              Credits already added
            </Typography>
            <Typography variant="h6" color="text.secondary" sx={{ marginBottom: 4 }}>
              This purchase was already applied to your account.
            </Typography>
          </>
        )}

        {status === "error" && (
          <>
            <Typography variant="h3" gutterBottom>
              We couldn't confirm this purchase yet
            </Typography>
            <Typography variant="h6" color="text.secondary" sx={{ marginBottom: 4 }}>
              If you were charged, your credits will still be added automatically shortly.
              Contact <Link href="mailto:orders@creataai.com">orders@creataai.com</Link> if
              they don't appear.
            </Typography>
          </>
        )}

        {status !== "loading" && (
          <Typography variant="body1" color="text.secondary">
            Open the Creata Ai app and your credit balance will already be updated - nothing
            else to do.
          </Typography>
        )}
      </Container>
      <MarketingFooter />
    </main>
  );
};

export default TopupSuccess;
